import {Component, ChangeDetectionStrategy} from '@angular/core';
@Component({
    selector: 'app-mandating-flow-info-card',
    templateUrl: './mandating-flow-info-card.component.html',
    styleUrls: ['./mandating-flow-info-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MandatingFlowInfoCardComponent {
}
